export default __webpack_public_path__ + "static/summer_containers0-83a5d08669a72d451ecf296629846acc.webp";